import styles from './NumberOfRecentTransactions.module.less';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import { SUPPORT_TO_COMMENT_TEXT_KEY } from '../../i18n/project-i18n-model';
import { Icon } from '@sb1/ffe-icons-react';
import volunteerActivism from '@sb1/ffe-icons/icons/open/300/md/volunteer_activism.svg';
import { SmallText } from '@sb1/ffe-core-react';

export const PromoteGiveForActivityList = () => {
    const texts = useI18nTexts([SUPPORT_TO_COMMENT_TEXT_KEY]);

    return (
        <div className={`${styles.wrapper} ${styles.mobileWrapper} ${styles.activityPromotionText}`}>
            <Icon fileUrl={volunteerActivism} className={styles.commentIcon} />
            <SmallText className={styles.supportedNumber}>{texts[SUPPORT_TO_COMMENT_TEXT_KEY]}</SmallText>
        </div>
    );
};
